
<div
  class="block-title d-flex flex-column flex-md-row align justify-content-center justify-content-md-between align-items-md-center ps-3 pe-3">
  <h3>{{ title }}</h3>
  <ng-container *ngTemplateOutlet="headerTemplate">
  </ng-container>
</div>
<div class="block-content">
  @if (contentTemplate; as a) {
    <ng-container *ngTemplateOutlet="contentTemplate">
    </ng-container>
  } @else {
    <div class="ps-3 pe-3 pt-4 pb-4">
      @if (!error) {
        <ls-spinner></ls-spinner>
      }
      @if (error) {
        <div class="text-warning">
          <fa-icon icon="exclamation-triangle"></fa-icon>
          Ce service est indisponible pour le moment
        </div>
      }
    </div>
  }
</div>
